export const DEFAULTS = {
    POLLING_INTERVAL_MS: 2000,
    ANIMATION_DURATION: 0.15,
};
